import type { ImageRef } from '../core';

export type ResultWrapper<T> = { status: 'CANCELED' } | { status: 'OK'; data: T };

export type ImageInput = string | ImageRef;

/**
 * @hidden
 */
export type SerializedImageInput =
  | {
      imageFileUri: string;
    }
  | Awaited<ReturnType<ImageRef['serialize']>>;
